module.exports = __webpack_public_path__ + "img/launch-progress.d3fc687b.gif";